import "../vendor/popup.min.js";
import FuiModuleModifier, {
  type Signature as FuiModuleSignature
} from "./fui-module";

interface S extends FuiModuleSignature {
  Args: {
    Named: {
      position?: string;
      inline?: boolean;
      hoverable?: boolean;
      content?: string;
    };
    Positional: [settings?: Record<string, unknown>];
  };
}

export default class FuiPopupModifier extends FuiModuleModifier<S> {
  override semanticModuleName = "popup";
}
